import * as $ from 'jquery';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { HttpModule, Http } from '@angular/http';
import { Routes, RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SpinnerComponent } from './shared/spinner.component';
import { WebComponent } from './web/web.component';
import { TermsComponent } from './terms/terms.component';
import { AuthService } from './web/auth.service';
import { VerifyService } from './global/verify.service';

import { ToastModule } from 'ng2-toastr/ng2-toastr';

import {TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ShowHidePasswordModule } from 'ngx-show-hide-password';
import { LocalizeRouterModule } from 'localize-router';
// import { routes } from './app-routing.module';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TermsPacComponent } from './terms-pac/terms-pac.component';
import { TermsSatComponent } from './terms-sat/terms-sat.component';
import { PolicyComponent } from './policy/policy.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    WebComponent,
    TermsComponent,
    TermsPacComponent,
    TermsSatComponent,
    PolicyComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ToastModule.forRoot(),
    ShowHidePasswordModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
      }
  }),
    HttpModule,
    AppRoutingModule,
    CommonModule
  ],
  providers: [
    {
    provide: LocationStrategy,
    useClass: HashLocationStrategy
    },
    AuthService,
    VerifyService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts